<section class="loader-section">
    <mat-spinner></mat-spinner>
</section>
